import { graphql, useStaticQuery } from "gatsby"
import { useLocale } from "../../hooks"

export const useSiteQuery = () => {
  const locale = useLocale()

  const {
    allContentfulDigitupGlobalSite: { edges },
  } = useStaticQuery(
    graphql`
      query globalSite {
        allContentfulDigitupGlobalSite {
          edges {
            node {
              node_locale
              headerLogo {
                title
                gatsbyImageData
                height
                width
                file {
                  url
                }
              }
              footerLogo {
                title
                gatsbyImageData
                height
                width
                file {
                  url
                }
              }
              headerButton {
                ...componentLink
              }
              headerItems {
                __typename
                ...componentHeaderLink
              }
              footerCopyrightItems {
                __typename
                ...componentLink
              }
              subscribeNewsletter
              footerPrivacy {
                footerPrivacy
              }
              headerBlogMedia {
                name
                slider {
                  image1 {
                    gatsbyImageData
                    title
                  }
                  image2 {
                    gatsbyImageData
                    title
                  }
                  image3 {
                    gatsbyImageData
                    title
                  }
                  image4 {
                    gatsbyImageData
                    title
                  }
                    image5 {
                    gatsbyImageData
                    title
                  }
                    image6 {
                    gatsbyImageData
                    title
                  }
                    image7 {
                    gatsbyImageData
                    title
                  }
                  content
                  mobileContent
                  backgroundColor
                }
              }
              footerItems {
                __typename
                ... on ContentfulComponentLinkGroup {
                  title
                  sections {
                    title
                    target {
                      ...linkTarget
                    }
                    slug
                  }
                }
              }
              footerCopyrightText
              quoteSection {
                ...componentLink
              }
              headerBlogTitle
              quoteSectionTitle
              footerButtonPlaceholder
              footerButton
              footerPrivacyText{
                raw
                references {
                    ...richTextReference
                }
              }
              footerFirstPara {
                raw
              }
              newsletterErrorMessage
              footerLinkedin
              loaderText
            }
          }
        }
      }
    `
  )

  const localeData = locale
    ? edges.filter(({ node }) => node.node_locale === locale)
    : edges.filter(({ node }) => node.node_locale === "en-US")
  const site = localeData.reduce((acc, val) => ({ ...acc, ...val.node }), {})


  return site
}